<div class="filters" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListConnectedTo]="[deleteArea]" cdkDropListLockAxis="x"
  (cdkDropListDropped)="onDropPosFilter($event)">
  <div class="filter-tabs">
    <div *ngFor="let filter of getShowFilters()" class="filter-tab">
      <button cdkDrag [cdkDragData]="filter" class="btn btn-filter btn-filter-primary dropdown-toggle" [dropdown]="dropdownContent"
        (onDropdownShow)="onShowFilter(filter, dropdownContent)" [tooltip]="filter.value ? filter.value : ''" tooltipPlacement="bottom">
        <i class="icon-drag-indicator"></i> {{ filter.title }} <span *ngIf="filter.value">: {{ filter.value }}</span>
      </button>
      <ng-template #dropdownContent let-dr="dropdown">
        <div [ngSwitch]="filter.title" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
          <div *ngSwitchCase="'Date received'">
            <div class="date-filter-drop mx-15">
              <input-search-period #dateReceivedInput type="date" [autoApply]="false"
                (change)="onChangeFilterValue($event.start === null ? '' : $event, filter);dr.hide()" [placeholder]="'Date'"></input-search-period>
            </div>
          </div>
          <div *ngSwitchCase="'Date created'">
            <div class="date-filter-drop mx-15">
              <input-search-period #dateCreatedInput type="date" [autoApply]="false"
                (change)="onChangeFilterValue($event.start === null ? '' : $event, filter);dr.hide()" [placeholder]="'Date'"></input-search-period>
            </div>
          </div>
          <div *ngSwitchCase="'Phone'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.phoneNumbers" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.phoneNumbers, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'TelQ ID'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.telqId" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.telqId, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Sender ID'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.sender" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.sender, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'SMSC'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <input [(ngModel)]="model.smsc" class="form-control" type="text" [ngModelOptions]="{standalone: true}">
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.smsc, filter);dr.hide();">Submit</button>
            </div>
          </div>
          <div *ngSwitchCase="'Text'">
            <div class="mx-10">
              <h5 class="text-muted">{{ filter.title }}</h5>
              <textarea [(ngModel)]="model.text" class="form-control text-input" type="text" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onChangeFilterValue(model.text, filter);dr.hide();">Submit</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="filter-controls">
    <button class="btn btn-filter filter-add-btn" [disabled]="!getHiddenFilters().length" [dropdown]="hiddenFilters">
      <i class="icon-add"></i> Add Filter
    </button>
    <ng-template #hiddenFilters let-dr="dropdown">
      <ul class="dropdown-menu rounded-15 bg-neutral-n1">
        <li *ngFor="let filter of getHiddenFilters()" class="dropdown-item filter-item px-15 py-10" (click)="onClickShowFilter(filter, dr)">
          <a>{{ filter.title }}</a>
        </li>
      </ul>
    </ng-template>
    <button cdkDropList cdkDropListLockAxis="x" #deleteArea="cdkDropList" (cdkDropListDropped)="onDropFilter($event)" class="btn btn-filter delete-area"
      (click)="resetFilters()">
      <i class="far fa-trash-alt"></i> Clear
    </button>
  </div>
</div>
